import { render, staticRenderFns } from "./CourseDayCandidateExamInfo.vue?vue&type=template&id=08bf9c82&scoped=true&lang=pug&"
import script from "./CourseDayCandidateExamInfo.vue?vue&type=script&lang=js&"
export * from "./CourseDayCandidateExamInfo.vue?vue&type=script&lang=js&"
import style0 from "./CourseDayCandidateExamInfo.vue?vue&type=style&index=0&id=08bf9c82&lang=scss&scoped=true&"
import style1 from "./CourseDayCandidateExamInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf9c82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VDivider,VSpacer,VTooltip})
